/* Public Acolite lookup; no TikTok credentials are stored in the theme. */
if (!customElements.get('ghost-tiktok-videos')) {
  class GhostTikTokVideos extends HTMLElement {
    static observedAttributes = ['data-product-ids','data-product-id','data-limit','data-exclude','data-heading','data-captions','data-desktop-columns','data-mobile-columns'];
    constructor() {
      super(); this.attachShadow({mode:'open'}); this.sequence=0; this.selection=0;
      this.onProduct = this.onProduct.bind(this);
      this.onMessage = this.onMessage.bind(this);
    }
    connectedCallback() {
      this.build(); this.load();
      document.addEventListener('shopify:product:select',this.onProduct);
      window.addEventListener('message',this.onMessage);
    }
    disconnectedCallback() {
      document.removeEventListener('shopify:product:select',this.onProduct);
      window.removeEventListener('message',this.onMessage);
      this.resizeObserver?.disconnect(); cancelAnimationFrame(this.scrollFrame); clearTimeout(this.timer); this.controller?.abort(); this.sequence++; this.selection++;
    }
    attributeChangedCallback(name, oldValue, value) {
      if (oldValue===value || !this.isConnected || !this.row) return;
      // Stop previous product playback immediately, even before the next render.
      this.controller?.abort(); this.sequence++; this.row.replaceChildren();
      clearTimeout(this.timer);
      this.timer=setTimeout(()=>{if(this.isConnected){this.build();this.load();}},0);
    }
    async onProduct(event) {
      const picker=event.target.closest?.('variant-picker');
      if(!picker || picker.closest('product-card,quick-add-dialog')) return;
      const featured=picker.closest('featured-product-information');
      if(featured ? !featured.contains(this) : picker.dataset.templateProductMatch!=='true') return;
      const selection=++this.selection;
      try {
        const result=await event.promise;
        if(!this.isConnected || selection!==this.selection) return;
        const html=result?.detail?.html;
        const replacement=Array.from(html?.querySelectorAll?.('ghost-tiktok-videos') || []).find(node=>node.dataset.blockId===this.dataset.blockId);
        if(replacement) {
          this.setAttribute('data-product-id',replacement.dataset.productId || '');
          this.setAttribute('data-product-ids',replacement.dataset.productIds || '');
        } else {
          const id=String(result?.detail?.newProduct?.id || result?.detail?.productId || '').split('/').pop();
          if(id && id!==this.dataset.productId) {
            this.setAttribute('data-product-id',id);
            this.setAttribute('data-product-ids',''); // Never show the old child's videos.
          }
        }
      } catch (_) { /* The theme cancelled the selection. */ }
    }
    ids(value) {
      return [...new Set(String(value || '').split(/[\s,;]+/).map(s=>s.trim()).filter(Boolean))];
    }
    el(tag, cls, text) {
      const node=document.createElement(tag); if(cls)node.className=cls;
      if(text!==undefined)node.textContent=text; return node;
    }
    build() {
      this.resizeObserver?.disconnect(); this.videos=[]; this.shadowRoot.replaceChildren(); this.removeAttribute('data-empty');
      const css=this.el('link');css.rel='stylesheet';css.href=this.dataset.css;
      const section=this.el('section');section.setAttribute('aria-label',this.dataset.heading || 'Creator videos');
      const header=this.el('header');header.append(this.el('h2','',this.dataset.heading || 'Seen on TikTok'));
      this.nav=this.el('div','nav');
      for(const [label,direction] of [['Previous videos',-1],['Next videos',1]]) {
        const button=this.el('button','arrow',direction===-1?'←':'→');button.type='button';button.setAttribute('aria-label',label);
        button.addEventListener('click',()=>{
          this.navigate(direction);
        });this.nav.append(button);
      }
      header.append(this.nav);
      this.status=this.el('p','status');this.status.setAttribute('role','status');
      this.row=this.el('div','row');this.row.tabIndex=0;this.row.setAttribute('role','region');this.row.setAttribute('aria-label','Creator video carousel');
      this.more=this.el('span');this.more.hidden=true;
      this.row.addEventListener('scroll',()=>{cancelAnimationFrame(this.scrollFrame);this.scrollFrame=requestAnimationFrame(()=>this.loadVisible());});
      this.resizeObserver=new ResizeObserver(()=>this.loadVisible());this.resizeObserver.observe(this.row);
      css.addEventListener('load',()=>this.loadVisible());
      this.retry=this.el('button','','Try again');this.retry.type='button';this.retry.hidden=true;this.retry.addEventListener('click',()=>this.load());
      section.append(header,this.status,this.retry,this.row,this.more);this.shadowRoot.append(css,section);
    }
    async load() {
      const sequence=++this.sequence;this.controller?.abort();this.controller=new AbortController();
      this.removeAttribute('data-empty');this.row.replaceChildren();this.more.hidden=true;this.nav.hidden=true;this.retry.hidden=true;
      const ids=this.ids(this.dataset.productIds);
      if(!ids.length) {
        this.status.textContent='Add TikTok product IDs to custom.new_tt_prod_id, one per line.';
        if(this.dataset.designMode!=='true')this.setAttribute('data-empty','');
        this.removeAttribute('aria-busy');return;
      }
      if(ids.some(id=>!/^\d+$/.test(id))) {this.status.textContent='TikTok product IDs must contain digits only, one per line.';return;}
      this.status.textContent='Loading creator videos…';this.setAttribute('aria-busy','true');
      const requestController=this.controller;
      const timeout=setTimeout(()=>requestController.abort(),30000);
      try {
        const response=await fetch('https://acolite.designerparfums.com/api/public/tiktok/product-videos',{
          method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(ids),credentials:'omit',signal:this.controller.signal
        });
        if(!response.ok)throw Error('Request failed');
        const data=await response.json();
        if(sequence!==this.sequence || !this.isConnected)return;
        if(data.ok!==true || !Array.isArray(data.videos))throw Error('Invalid response');
        const seen=new Set(this.ids(this.dataset.exclude));
        this.videos=data.videos.filter(video=>{
          if(typeof video.videoId!=='string' || !/^\d+$/.test(video.videoId) || seen.has(video.videoId))return false;
          if(!Array.isArray(video.matchedProductIds) || !video.matchedProductIds.some(id=>ids.includes(id)))return false;
          seen.add(video.videoId);return true;
        }).slice(0,Math.min(40,Math.max(4,Number(this.dataset.limit)||30)));
        this.autoplayStarted=false;
        if(!this.videos.length){this.status.textContent='No creator videos found for this product.';if(this.dataset.designMode!=='true')this.setAttribute('data-empty','');return;}
        this.status.textContent='';this.nav.hidden=false;
        this.row.replaceChildren(...this.videos.map(video=>this.card(video)));this.row.scrollLeft=0;this.targetIndex=0;this.loadVisible(true);
      } catch(error) {
        if(sequence!==this.sequence || !this.isConnected)return;
        this.status.textContent='Creator videos could not be loaded. Please try again.';this.retry.hidden=false;
      } finally {clearTimeout(timeout);if(sequence===this.sequence)this.removeAttribute('aria-busy');}
    }
    columns() {
      const mobile=window.matchMedia('(max-width: 749px)').matches;
      return Math.max(1,Number(mobile?this.dataset.mobileColumns:this.dataset.desktopColumns)||(mobile?1:4));
    }
    stride() {
      const cards=this.row.children;
      return cards.length>1 ? cards[1].offsetLeft-cards[0].offsetLeft : this.row.clientWidth;
    }
    navigate(direction) {
      const step=this.stride();if(!step)return;
      const current=Math.round(this.row.scrollLeft/step);
      this.targetIndex=Math.max(0,Math.min(this.videos.length-this.columns(),Math.max(0,current+direction)));
      this.pausePlayers();this.preloadRange(this.targetIndex,this.columns());
      this.row.scrollTo({left:this.targetIndex*step,behavior:'smooth'});
    }
    preloadRange(start,count,autoplay=false) {
      for(let i=start;i<Math.min(this.videos.length,start+count);i++){
        const card=this.row.children[i];if(card)this.mountPlayer(card,this.videos[i],autoplay&&i===0);
      }
    }
    loadVisible(initial=false) {
      if(!this.videos?.length || !this.row.clientWidth)return;
      const step=this.stride();if(step<=0)return;
      const start=Math.max(0,Math.round(this.row.scrollLeft/step));
      this.preloadRange(start,this.columns(),initial || !this.autoplayStarted);
      this.autoplayStarted=true;
      const buttons=this.nav.querySelectorAll('button');
      buttons[0].disabled=start===0;
      buttons[1].disabled=start>=Math.max(0,this.videos.length-this.columns());
      // Stop audio/video that has moved outside the displayed cards.
      [...this.row.children].forEach((card,i)=>{if(i<start || i>=start+this.columns()){
        card.querySelector('iframe')?.contentWindow?.postMessage({'x-tiktok-player':true,type:'pause'},'https://www.tiktok.com');
      }});
    }
    mountPlayer(card,video,autoplay=false) {
      const stage=card.querySelector('.stage');if(stage.querySelector('iframe') || stage.dataset.failed)return;
      const iframe=this.el('iframe');
      iframe.src=`https://www.tiktok.com/player/v1/${video.videoId}?controls=1&description=0&music_info=0&autoplay=${autoplay?1:0}&muted=${autoplay?1:0}&rel=0`;
      iframe.title=`TikTok video by ${video.creatorName || video.creatorUsername || 'creator'}`;
      iframe.allow='autoplay; fullscreen; encrypted-media; picture-in-picture';iframe.allowFullscreen=true;
      stage.replaceChildren(iframe);
    }
    card(video) {
      const card=this.el('article','card');const stage=this.el('div','stage');
      const play=this.el('button','play');play.type='button';
      const creator=video.creatorName || video.creatorUsername || 'TikTok creator';
      play.append(this.el('span','play-icon','▶'),this.el('span','','Watch video'),this.el('small','',creator));
      play.setAttribute('aria-label',`Watch TikTok video by ${creator}`);
      play.addEventListener('click',()=>{this.pausePlayers();this.mountPlayer(card,video,true);});
      stage.append(play);card.append(stage,this.el('p','creator',creator));
      if(this.dataset.captions==='true' && video.title)card.append(this.el('p','caption',video.title));
      const link=this.el('a','external','View on TikTok ↗');
      link.href=`https://www.tiktok.com/@${encodeURIComponent(video.creatorUsername || '_')}/video/${video.videoId}`;
      link.target='_blank';link.rel='noopener noreferrer';card.append(link);return card;
    }
    pausePlayers(except) {
      for(const frame of this.shadowRoot.querySelectorAll('iframe')) {
        if(frame.contentWindow!==except)frame.contentWindow?.postMessage({'x-tiktok-player':true,type:'pause'},'https://www.tiktok.com');
      }
    }
    onMessage(event) {
      if(event.origin!=='https://www.tiktok.com' || !event.data?.['x-tiktok-player'])return;
      const frame=[...this.shadowRoot.querySelectorAll('iframe')].find(f=>f.contentWindow===event.source);
      if(!frame)return;
      if(event.data.type==='onStateChange' && event.data.value===1)this.pausePlayers(event.source);
      if(event.data.type==='onPlayerError' && event.data.value?.errorCode!==3002){const stage=frame.parentElement;stage.dataset.failed='true';stage.replaceChildren(this.el('p','unavailable','This video is unavailable. Try the TikTok link below.'));}
    }
  }
  customElements.define('ghost-tiktok-videos',GhostTikTokVideos);
}
